<template>
    <div>
        <v-dialog
            v-model="dialog"
            class="primary darken-1"
            max-width="400"
        >
            <v-card class="primary darken-1 py-6 px-1">
                <v-btn class=" ml-2 button-text" color="secondary lighten-1" text @click="dialog = false">
                    <v-icon class="mr-1">mdi-close-circle-outline</v-icon>
                    Fechar
                </v-btn>

                <v-card-text class="mt-6">
                    <div class="display: flex; align-items: center;">
                        <v-icon class="mr-2">mdi-cog-outline</v-icon>
                        <strong class="white--text" style="font-size: 20px;line-height: 23px;">Configurar exportação</strong>
                    </div>
                    <v-form ref="form">
                        <v-radio-group v-model="optionSelected" mandatory>
                            <v-radio 
                                v-for="(option, index) in settingOptions" 
                                :key="index"
                                :value="option.value"
                                class="my-3"
                                color="secondary lighten-1"
                            >
                                <template v-slot:label>
                                    <div style="display: flex; align-items: center;">
                                        <span class="white--text">{{option.label}}</span>
                                        <div class="ml-2" style="max-width: 60px;">
                                            <v-text-field 
                                                v-if="index === 2" 
                                                v-model="replaceValue" 
                                                dense
                                                color="secondary lighten-1"
                                                :disabled="!index === 2"
                                                :rules="[replaceValueRules]"
                                            >
                                            </v-text-field>
                                        </div>
                                    </div>
                                </template>
                            </v-radio>
                        </v-radio-group>
                    </v-form>
                </v-card-text>

                <v-card-actions>
                    <v-btn 
                        class="button-text px-4 py-6" 
                        color="secondary lighten-1"
                        @click="exportData"
                    >
                        Exportar
                    </v-btn>
                    <v-btn 
                        class="button-text px-4 py-6"  
                        text 
                        color="secondary lighten-1"
                        @click="dialog = false"
                    >
                        Cancelar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: "SettingsExportDialog",
    data: () => ({
        dialog: false,
        optionSelected: undefined,
        replaceValue: undefined,
        fileType: undefined,
        rules: [
            v => !!v || 'Necessário preencher'
        ],
        settingOptions: [
            { label: "Nenhuma configuração", value: "none" },
            { label: "Remover datas que não possuem dados", value: "remove-dates-with-empty-values" },
            { label: "Substituir dados ausentes por:", value: "replace-data" }
        ]
    }),
    computed:{
        replaceValueRules(){
            if(this.optionSelected === "replace-data" && !this.replaceValue){
                return 'Vazio';
            }
            return true;
        },
    },
    methods:{
        openSettingsDialog(fileType){
            this.dialog = true;
            this.fileType = fileType;
            setTimeout(()=>{
                this.$refs.form.reset();
                this.$refs.form.resetValidation();
            }, 100)
        },
        exportData(){
            if(this.$refs.form.validate()){
                this.$emit("exportData",{
                    fileType: this.fileType,
                    option: this.optionSelected,
                    replaceData: this.optionSelected === "replace-data" ? this.replaceValue : ""
                })
                this.dialog = false; 
            }
        }
    }
}
</script>

<style>

</style>